module.exports = __webpack_public_path__ + "img/gold.06b38082.png";